import { ReactNode } from "react";
import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import { BundleDropdown } from "components/icons/BundleDropdown";
import ToolTip from "components/design/toolTip";
import { Link } from "components/DesignSystem/Link/Link";

export type BundledTaskDropdownItem = {
  uuid: string;
  name: string;
  link: string;
  stateLabel: string;
  tagType: TagColorType;
};

type BundledTaskDropdownProps = {
  tasks: BundledTaskDropdownItem[];
  triggerLabel?: ReactNode;
  triggerTooltip?: string;
  triggerClassName?: string;
};

export const BundledTaskDropdown = ({
  tasks,
  triggerLabel,
  triggerTooltip,
  triggerClassName,
}: BundledTaskDropdownProps) => {
  const triggerIcon = (
    <Button customType="ghost_icon" size="xsmall">
      <BundleDropdown />
    </Button>
  );

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild className="t-group t-select-none">
        <div
          className={classNames(
            "t-flex t-items-center t-gap-1.5",
            triggerClassName
          )}
        >
          {triggerLabel}
          {triggerTooltip ? (
            <ToolTip text={triggerTooltip} propClass="t-ml-auto">
              <span>{triggerIcon}</span>
            </ToolTip>
          ) : (
            triggerIcon
          )}
        </div>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          sideOffset={4}
          align="start"
          side="bottom"
          className="t-max-h-64 t-overflow-auto t-max-w-md"
        >
          {tasks.map(({ uuid, name, link, stateLabel, tagType }) => (
            <Dropdown.Item key={uuid} textValue={name} asChild>
              <Link
                to={link}
                target="_blank"
                className="t-flex t-justify-between t-items-center t-gap-8 t-w-full"
              >
                <Button size="small" customType="link">
                  {name}
                </Button>
                <Tag tagType={tagType} icon={false} size="small">
                  {stateLabel}
                </Tag>
              </Link>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
